export const facilitiesQueryKeys = {
  all: ['facilities'] as const,
  lists: () => [...facilitiesQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...facilitiesQueryKeys.lists(), filters] as const,
  details: () => [...facilitiesQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...facilitiesQueryKeys.details(), id] as const,
};
